<section class="flex gap-4 overflow-auto py-[1px] px-5">
  @if (!readonly) {
    <div
      class="card button !py-0 relative h-32 w-32 min-w-32 !overflow-hidden !gap-2 items-center justify-center text-center"
    >
      <input
        class="cursor-pointer absolute h-full w-full top-0 left-0 opacity-0 p-0"
        type="file"
        [accept]="inputAccept"
        multiple
        (input)="
          uploadMedia($event);
          analyticsService.logEvent('user_content_media_upload')
        "
      />
      <span class="material-symbols-rounded min-h-fit text-black/60"
        >attach_file</span
      >
      <p class="leading-snug">{{ inputText }}</p>
    </div>
  }
  @for (singleMedia of mediaBlob; track media) {
    <div class="card !p-0 h-32 w-32 min-w-32 relative !overflow-hidden">
      @if (!readonly) {
        <span
          class="material-symbols-rounded cursor-pointer opacity-0 hover:opacity-100 text-white absolute !h-full !w-full top-0 left-0 bg-black/50 items-center justify-center flex"
          (click)="
            removeMedia(singleMedia);
            analyticsService.logEvent('user_content_remove_media_click')
          "
          >delete</span
        >
      }
      <div class="h-full pointer-events-none" [ngSwitch]="true">
        <!-- image preview -->
        <img
          *ngSwitchCase="isImage(singleMedia)"
          [src]="singleMedia.url"
          alt="A preview of the media selected by the user"
          class="object-cover h-full w-full"
        />
        <!-- video icon -->
        <span
          class="material-symbols-rounded !h-full !w-full flex items-center justify-center"
          *ngSwitchCase="isVideo(singleMedia)"
          >videocam</span
        >
        <!-- audio icon -->

        <span
          class="material-symbols-rounded !h-full !w-full flex items-center justify-center"
          *ngSwitchCase="isAudio(singleMedia)"
          >mic</span
        >

        <!-- loading icon -->
        <kor-spinner *ngSwitchDefault></kor-spinner>
      </div>
    </div>
  }
</section>
